import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles/occThankYou.scss';
import { useOCC } from './context/occContext';
import FormattedRichMessage from '../common/FormattedRichMessages';
const OCCCancelSettingsPage = () => {
  const {
    emailObj
  } = useOCC();

  //   const email = emailObj?.maskedEmail || 'your email';

  //   const maskEmail = (emailId) => {
  //     if (!emailId || !emailId.includes('@')) return emailId;

  //     const [name, domain] = emailId.split('@');
  //     const maskedName =
  //       name.length > 2
  //         ? `${name[0]}*****${name[name.length - 1]}`
  //         : `${name[0]}***`;

  //     return `${maskedName}@${domain}`;
  //   };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.occ_thankyou_container
  }, /*#__PURE__*/React.createElement("h1", {
    className: styles.occ_title
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.title",
    values: {
      email: emailObj === null || emailObj === void 0 ? void 0 : emailObj.maskedEmail
    }
  })), /*#__PURE__*/React.createElement("h2", {
    className: styles.occ_sub_heading
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "cancelled"
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.occ_text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.subtitle"
  })), /*#__PURE__*/React.createElement("hr", {
    className: styles.divider
  }), /*#__PURE__*/React.createElement("h2", {
    className: styles.occ_sub_heading
  }, "Your Current Settings"), /*#__PURE__*/React.createElement("p", {
    className: styles.occ_text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.Ul"
  })), /*#__PURE__*/React.createElement("ul", {
    className: styles.occ_list
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.note1"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.note2"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.note3"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.occ_links
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/email-security"
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.linkText"
  }))));
};
export default OCCCancelSettingsPage;